import { useEffect, useState } from "react";
import { LeadStatusClient, LeadStatusDTO } from "../services/apiClient";
import { API_BASE_URL } from "../config/config";
import axiosInstance from "../services/axiosInstance";

export const getLeadStatus = () => {
  const [leadStatuses, setLeadStatuses] = useState<LeadStatusDTO[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const leadStatusClient = new LeadStatusClient(API_BASE_URL, axiosInstance);

  useEffect(() => {
          const fetchLeadStatusNames = async () => {
              setIsLoading(true);
              try {
                  const result = await leadStatusClient.getLeadStatuss(); // Call the distinct table names endpoint
                  if (result && result.success && result.data) {
                    setLeadStatuses(result.data);
                  } else {
                      setError('Failed to fetch lead status names');
                  }
              } catch (err) {
                  setError('Error fetching lead status names');
                  console.error('Error fetching lead status names:', err);
              } finally {
                  setIsLoading(false);
              }
          };
  
          fetchLeadStatusNames();
      }, []);
  
      return { leadStatuses, isLoading, error };
};